// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const getValidateAmountMessage =
  (action: string, currBalance?: string, minAmount?: string) => (inputAmount: string) => {
    if (currBalance === undefined) {
      return '';
    }

    const input = parseFloat(inputAmount);
    const currentBalance = parseFloat(currBalance);

    const decimalPart = inputAmount.split('.')[1];
    if (decimalPart && decimalPart.length > 6) {
      return `${action} amount cannot have greater than 6 decimal precision`;
    }

    if (input > currentBalance) {
      return `${action} amount exceeds current holding balance`;
    }

    if (minAmount && input < parseFloat(minAmount)) {
      return `${action} amount is below the minimum burn amount of: ${parseFloat(minAmount).toFixed(6)}`;
    }    return '';
  };
